
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Client } from '@/components/clients/types';
import { fetchClientById } from '@/services/clientApiService';

export const useClient = (clientId: string | undefined): UseQueryResult<Client, Error> => {
  return useQuery<Client, Error>({
    queryKey: ['client', clientId],
    queryFn: async () => {
      if (!clientId) {
        throw new Error('Client ID is required for fetching.');
      }
      return fetchClientById(clientId);
    },
    enabled: !!clientId,
  });
};
